
















import { Vue, Component, Prop } from 'vue-property-decorator';
@Component({ components: {} })
export default class TeacherRegistComplete extends Vue {
  title = '登録完了';
  async goNext() {
    await this.$router.push({ path: '/' });
  }
}
